import React, { createContext, useState } from "react";

export const ImageIndexContext = createContext(); 

export const ImageIndexProvider = ({ children }) => {
  const [imageIndex, setImageIndex] = useState(0)

  return (
    <ImageIndexContext.Provider value={{ imageIndex, setImageIndex }}>
      {children} 
    </ImageIndexContext.Provider>
  );
};
